import { createSlice } from "@reduxjs/toolkit";

const PujaCategorySlice = createSlice({
  name: "pujaCategories",
  initialState: {
    isLoading: false,
    error: "",
    pujaCategoryList: [],
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setPujaCategoryList: (state, action) => {
      state.pujaCategoryList = action.payload;
    },
  },
});

export const { setLoading, setError, setPujaCategoryList } =
  PujaCategorySlice.actions;
export default PujaCategorySlice.reducer;
